import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import { HttpStatus, claimsHomeRoute } from 'config/Api.Config';
import React from 'react';
import { isDesktop, isMobile } from 'react-device-detect';
import usePayeeType, { PayeeTypeAction } from './PayeeType.Hooks';
import PayeeTypeDelete from './sections/PayeeType.Delete';
import PayeeTypeEdit from './sections/PayeeType.Edit';
import PayeeTypeFilters from './sections/PayeeType.Filters';
import PayeeTypeList from './sections/PayeeType.List';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export const payeeTypeIndexRoute = claimsHomeRoute + '/payeeType/:action?/:id?';
export default function PayeeTypeIndex() {
  const { lang } = getLocales();
  const payeeTypeHook = usePayeeType();

  if (!payeeTypeHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={payeeTypeHook}
        render={({ listApi, views, pageRouter }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.payeeTypes} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <PayeeTypeFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    data={{ action: PayeeTypeAction.EDIT }}
                  />
                </Box>
              </>
            }
            subHeader={isDesktop && <PayeeTypeFilters />}
            render={
              <>
                {views.edit && <PayeeTypeEdit />}
                {views.delete && <PayeeTypeDelete />}
                <PayeeTypeList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
